import {
    getPerPageOptions,
    onTooltipShow, getDate
} from '@shared/components/admin/pages/Management/common-data';

// booleanSelectKeys: 기본값이 null 이고 선택지 값이 true/false 인 select 필드. 쿼리의 'true'/'false' 를 boolean 으로 복원한다.
// 쿼리는 문자열이라 비교는 문자열 기준으로 한다.
const normalize = v => v == null ? null : String(v);

export default function PaginationPageMixin({searchForm = {}, pagination = {}, booleanSelectKeys = []}) {
    return {
        data() {
            return {
                listLoading: false,
                searchResults: null,
                searchFormValue: JSON.parse(JSON.stringify(searchForm)),
                pagination: pagination,
                perPageOptions: getPerPageOptions()
            };
        },
        computed: {
            get_tooltip_title() {
                return (data) => {
                    return data ? {title: data} : null;
                };
            },
            get_date() {
                return (date) => {
                    return getDate(date);
                };
            }
        },
        mounted() {
            this.$root.$on('bv::tooltip::show', this.onTooltipShow);
        },
        beforeDestroy() {
            this.$root.$off('bv::tooltip::show', this.onTooltipShow);
        },
        methods: {
            onTooltipShow,
            setSearchDataFormQuery() {
                Object.keys(this.searchFormValue).forEach(key => {
                    const value = this.$route.query[key];
                    if (typeof searchForm[key] === 'boolean') {
                        // 쿼리는 문자열이라 boolean 필드는 'true' 만 true 로 복원 (false 는 쿼리에 싣지 않음)
                        this.searchFormValue[key] = value === 'true';
                    } else if (value !== undefined) {
                        this.searchFormValue[key] = booleanSelectKeys.includes(key) && (value === 'true' || value === 'false')
                            ? value === 'true' : value;
                    } else {
                        this.searchFormValue[key] = null;
                    }
                });
                
                if (this.pagination != null) {
                    this.pagination.currentPage = Number(this.$route.query.current_page) || 1;
                    this.pagination.perPage = Number(this.$route.query.per_page) || 20;
                }
            },
            async changeQuery({page, pageSize}) {
                const query = {
                    ...this.$route.query,
                };
                let checkSameQuery = true;
                
                
                // 페이지 이동(page/pageSize 지정)은 아직 제출하지 않은 검색 폼 값을 섞지 않고 URL 에 적용된 값만 유지.
                // 검색 제출(changeQuery({}))일 때만 폼 값을 URL 에 반영한다.
                const isPaging = page !== undefined || pageSize !== undefined;
                const toQueryObj = isPaging ? {} : {
                    ...this.searchFormValue,
                };
                if (this.pagination != null) {
                    toQueryObj.current_page = page ?? this.pagination.currentPage;
                    toQueryObj.per_page = pageSize ?? this.pagination.perPage;
                }
                
                Object.entries(toQueryObj).forEach(([key, item]) => {
                    // 기본값이 boolean 인 필드(체크박스)만 false 를 쿼리에 싣지 않는다 ('false' 문자열이 truthy 로 읽히는 것 방지).
                    // 기본값이 null 인 선택 필드의 false(예: 활성 상태: 비활성)는 필터 값이므로 실어야 한다.
                    const value = item === false && typeof searchForm[key] === 'boolean' ? null : item;
                    if (normalize(query[key]) !== normalize(value)) {
                        checkSameQuery = false;
                        query[key] = value;
                    }
                });
                
                if (!checkSameQuery) {
                    await this.$router.push({query}).catch(e => {
                    });
                }
                return checkSameQuery;
            },
            resetForm() {
                this.searchFormValue = JSON.parse(JSON.stringify(searchForm));
                if (this.pagination != null) {
                    this.pagination.currentPage = 1;
                }
            },
        },
    };
}
